import * as React from "react"
import * as ReactDom from "react-dom"
import Gallery from "../components/views/Gallery";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";


/*declare global {
    interface Window {
        a2a_config: any
    }
}*/

export const page = async () => {
    const galleryContainer = document.getElementById('galeria')
    const GALLERYINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: galleryContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Gallery  data={GALLERYINFO} />, galleryContainer)
    setCurrentPage('gallery')
       
}
/*
const shares = document.querySelector('#shares-icons');
document.addEventListener('DOMContentLoaded', function(){
    shareRedes();
})

const shareRedes = () => {
    let arrayElements = document.querySelectorAll('.af-gallery__item')
    arrayElements.forEach(function(element){
        element.addEventListener('click', function(e){
            setTimeout(function(){
                const container = document.querySelector('.shareIcons');
                container.appendChild(shares.childNodes[1]);
                getBack();
            }, 1000);
            const textShare = 'Te invitamos a votar por este gran dibujo en nuestra pagina web. El ganador verá su obra expuesta en el mural'
            window.a2a_config.templates.facebook = {
                quote: textShare
            };
            window.a2a_config.templates.twitter = {
                text: textShare + " ${link}",
            };
            window.a2a_config.templates.whatsapp = {
                text: textShare + " ${link}",
            };
        })
    })
}

const getBack = () => {
    let btn = document.querySelector('.af-gallery__getback');
    btn.addEventListener('click', function(e){
        setTimeout(function(){
            shareRedes();
        }, 1000);
    })
}*/

document.addEventListener('DOMContentLoaded', function(){
    share();
})


const share = () =>{
    let arrayElements = document.querySelectorAll('.af-gallery__item')
    arrayElements.forEach(function(element){
        element.addEventListener('click', function(e){
            setTimeout(function(){
                let btnFace = document.querySelector('.facebookShare') as any;
                btnFace.addEventListener('click', function(e:any){
                    let btnFacebook = document.querySelector('#shares-icons span .a2a_button_facebook') as any;
                    btnFacebook.href =`https://www.addtoany.com/add_to/facebook?linkurl=`+window.location.host+`%2Fes%2Fgaleria&t=Galeria&quote=Te%20invitamos%20a%20votar%20por%20este%20gran%20dibujo%20en%20nuestra%20pagina%20web.%20El%20ganador%20ver%C3%A1%20su%20obra%20expuesta%20en%20el%20mural&_rdc=1&_rdr`;
                    btnFacebook.click()
                })

                let btnTwit = document.querySelector('.twitterShare') as any;
                btnTwit.addEventListener('click', function(e:any){
                    let btnTwitter = document.querySelector('#shares-icons span .a2a_button_twitter') as any;
                    btnTwitter.href =`https://twitter.com/intent/tweet?text=Te%20invitamos%20a%20votar%20por%20este%20gran%20dibujo%20en%20nuestra%20pagina%20web.%20El%20ganador%20ver%C3%A1%20su%20obra%20expuesta%20en%20el%20mural%20http%3A%2F%2F`+window.location.host+`%2Fes%2Fgaleria&related=AddToAny,micropat`;
                    btnTwitter.click()
                })
                getBack();
            }, 1000);
          
        })
    })
    
}

const getBack = () => {
    let btn = document.querySelector('.af-gallery__getback');
    btn.addEventListener('click', function(e:any){
        setTimeout(function(){
            share();
        }, 1000);
    })
}